export default __webpack_public_path__ + "static/media/accountIcon.3a938517.svg";